<template>
  <div class="burger-icon burger-fixed-bottom">
    <button @click="clickBurger">
      <div class="container">
        <svg
          class="big-mac"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 79.13 67.56"
        >
          <g class="bun-bottom">
            <path
              d="M31,67.31c-13-.74-20.63-3-23.62-4a3.6,3.6,0,0,1-2.17-2.16,14.08,14.08,0,0,1-.71-3,6.43,6.43,0,0,0,4.13,1.39c2.19-.15,3.6-.85,4.91-.41s3.08,1.82,5.12,1.34a10.64,10.64,0,0,0,4.42-2,.63.63,0,0,1,.72,0,16.1,16.1,0,0,1,4.69,4.86C29.72,65.42,30.44,66.61,31,67.31Z"
              fill="#e6a65d"
            />
            <path
              d="M74.18,58.37A25.48,25.48,0,0,1,73.56,61a3.49,3.49,0,0,1-2.07,2.25C68,64.56,58.25,67.56,40,67.56c-1.93,0-3.77,0-5.53-.09a5.28,5.28,0,0,0,.88-1.06c1.31-2,3.67-6.67,5.55-7.13A13.91,13.91,0,0,1,48,60c1.77.82,3.28,1.76,5.21,1.53,2.88-.34,3.16-3.31,5.16-3.36a5.22,5.22,0,0,1,2.83.77,6.82,6.82,0,0,0,5.46,0c2.18-1.08,1.93-1.43,3.21-1.39s2.06.86,4.27.8Z"
              fill="#e6a65d"
            />
          </g>
          <g class="sauce-bottom">
            <path
              d="M42.76,57.78c.48.26,3.57-.18,5.47.64s2.62,1.73,3.93,1.82c2.68.18,2.86-2.81,5.17-3.27,2.12-.42,1.23-1.45-1.66-.68-3.08.83-3-1.53-5.33-1.34-1.39.11-1.57,1.79-5,1.67C43.35,56.58,42.23,57.51,42.76,57.78Z"
              fill="#edc8a3"
            />
          </g>
          <g class="beef-bottom">
            <path
              d="M4,49.91C7,49.7,8.13,51,9.47,51.26a14.37,14.37,0,0,0,3.34.22c1.56,0,4.24.65,12,.9s11.29-1.38,19-2.2a22.17,22.17,0,0,1,10.25,1.54,1.38,1.38,0,0,0,1.09,0A24.37,24.37,0,0,1,59,50.41c1.69-.35,3,.54,3.92.74s1.43-.5,2.4-.59c2-.19,2.54,1.1,4.22,1.07a7.18,7.18,0,0,0,2.8-.7,4.58,4.58,0,0,1,2.2.25,1.27,1.27,0,0,0,.7-1.15A9.12,9.12,0,0,0,74,45.7a2,2,0,0,0-1.6-1c-19.1-1.21-59.32-.44-66-.29a1.83,1.83,0,0,0-1.54.89,7,7,0,0,0-1,4.3A1.54,1.54,0,0,0,4,49.91Z"
              fill="#833921"
            />
          </g>
          <g class="cheese-bottom">
            <path
              d="M45.89,55.28c-9.84.72-11.55,14.33-14.3,9.86s-5-7.9-12.26-9.12c-3.38-.58-4.88-1.85-4.86-2.24.06-.81,2-.86,4.55-.47,12.18,1.86,17.33-1,23.16-1.54a31.28,31.28,0,0,1,10.21.54.15.15,0,1,1,0,.3C48.44,53.05,48,55.13,45.89,55.28Z"
              fill="#ffbc0d"
            />
          </g>
          <g class="lettuce-bottom">
            <path
              d="M2.09,55.87a.39.39,0,0,0,.22.51.37.37,0,0,0,.18,0c2.94-.49,2.6,1.27,4.57,1.77a11.74,11.74,0,0,0,4.05-.29c4-.69,3.5,1.31,6.41,1.25a8.56,8.56,0,0,0,3.22-.78A.28.28,0,0,0,20.9,58a.27.27,0,0,0-.16-.17c-2-.69-8.11-.81-8.26-4.35a.43.43,0,0,0-.45-.41H12a7.53,7.53,0,0,1-5.48-1.35A4.51,4.51,0,0,0,1.36,52a.11.11,0,0,0-.06.14.11.11,0,0,0,.12.07c1.5,0,3.3.94,2.08,1.91A4.31,4.31,0,0,0,2.09,55.87Z"
              fill="#a9c23f"
            />
            <path
              d="M60.16,51.78c-2-.37-3.94,1.3-4.94,1.82a5.34,5.34,0,0,1-2.71.35.08.08,0,0,0-.1.07.08.08,0,0,0,0,.09,4.23,4.23,0,0,0,2.14.91,17.1,17.1,0,0,0,3.91-.29c2.12-.09,2.28,3.09,5.66,3.22,2.65.1,3.14-3.15,8.06-1,2.94,1.28,5.17-1.31,6-2.48a.23.23,0,0,0,.07-.32.24.24,0,0,0-.33-.07c-3.22.82-3.15-1.65-5.33-1.73-1.65-.06-1.74,1.85-6.1-.06-1.21-.53-1.52.32-3.21.42C62,52.78,62.21,52.14,60.16,51.78Z"
              fill="#a9c23f"
            />
          </g>
          <g class="lettuce-middle">
            <path
              class="lettuce"
              d="M60.16,29a.15.15,0,0,0-.11-.18.17.17,0,0,0-.1,0,20.39,20.39,0,0,1-8.79,1.65c-1.39-.13-3.16-1.25-4.93-1.31-3.1-.12-5.55,1-8,2.08a.12.12,0,0,0-.06.16.12.12,0,0,0,.11.07,8,8,0,0,1,2.52.32c1.5.5,3.5,2.21,5.93,2.37a12.26,12.26,0,0,0,4.3-.5c1.48-.24,2.23.5,3.5,1.29,2,1.27,6.3,1,8.08,0,1.58-.82,3-2.82,3.89-3.5a.16.16,0,0,0,0-.22.16.16,0,0,0-.16-.07,10.44,10.44,0,0,1-5.73-.21c-1.22-.5-.77-1.36-.51-2Z"
              fill="#a9c23f"
            />
            <path
              class="lettuce"
              d="M19.87,29.25c-1.69,0-3.3,1.75-4.4,2.21a10.12,10.12,0,0,1-2.55.51.09.09,0,0,0-.05.1.08.08,0,0,0,.05,0c1.32.93,3.06,1.76,4.43,1.52,4.48-.77,6,1.65,7.85,1.76,2.71.18,3.71-1,5.69-.28a2.93,2.93,0,0,0,3.24-.71c1.71-1.41,2.3-.85,4-1.54a.24.24,0,0,0,0-.45,3.63,3.63,0,0,1-1.53-.56,6.31,6.31,0,0,0-3.89-1.61c-2.23,0-1.92.76-6.48.93-2.51.06-3.78-2-6.38-1.95Z"
              fill="#a9c23f"
            />
            <path
              class="lettuce"
              d="M9.7,36.92a6.9,6.9,0,0,1,3.87-2.43.21.21,0,0,0,.17-.26.22.22,0,0,0-.08-.13c-.86-.66-3.09-2.17-5.41-1.84-3.65.52-3.38,3.52-6.36,3.35A3.38,3.38,0,0,1,.34,35.2a.21.21,0,0,0-.3.07.19.19,0,0,0,0,.18c.32,1.1,1.2,3.18,3.34,3.06,1.56-.09,1.87-.84,2.91-1S8.2,38.55,9.7,36.92Z"
              fill="#a9c23f"
            />
            <path
              class="lettuce"
              d="M66,37.64c3.07.09,4.17-1.86,8.24-.26,1.9.75,4.22,0,4.92-1.37.07-.14,0-.29-.17-.23-.92.41-3.38.89-2.93-1.11.15-.67,0-1.5-1.61-1.37a10.42,10.42,0,0,1-2.84.21c-.94-.17-1.46-.91-3.35-.9-2.66,0-3.11,3.54-6.75,3.59a.15.15,0,0,0-.15.13.17.17,0,0,0,.07.13A10,10,0,0,0,66,37.64Z"
              fill="#a9c23f"
            />
          </g>
          <g class="sauce-middle">
            <path
              d="M22,35.57a.07.07,0,0,1,0,.14c-1.48.44-2.6,2.5-5,2.49-2.85,0-3.65-1.32-5.43-1.59a.07.07,0,0,1,0-.14,14.06,14.06,0,0,0,2-.63,9.78,9.78,0,0,1,3.93-1.24A16.18,16.18,0,0,1,22,35.57Z"
              fill="#edc8a3"
            />
            <path
              d="M51.38,34.63c-7.8,2.34-7.37-2-11.92-1.21-.75.12-1.73,1.18-3.35,1.2a1,1,0,0,0-1.08.71c-.23.73,1.33.34,3.84,1.68,1.25.68,1.85,1.88,3,1.93,1.6.05,2.69-1.46,3.75-1.54,1.27-.09,1.74.06,2.91-.1C50.39,37,53,34.16,51.38,34.63Z"
              fill="#edc8a3"
            />
          </g>
          <g class="beef-middle">
            <path
              d="M4,31.5a7.68,7.68,0,0,1,.94-4.43,1.49,1.49,0,0,1,.81-.71c2.62-.94,15-5,33.68-5s31.43,4.22,34.15,5.2a1.29,1.29,0,0,1,.8.81A5.14,5.14,0,0,1,74,31.6h0a7.59,7.59,0,0,1-2.33.15c-4.08-.21-2.33-1-4.22-1.51-1.43-.34-2.17.07-3.9.07-2.6,0-2.1-.93-1.88-1.77s-.48-1.79-2.57-.83a14.62,14.62,0,0,1-7.75,1.21c-1.86-.14-3.35-1.3-7.35-.83-3.42.4-5.23,1.32-6.52,1.53h-.89c-1.15-.18-2.08-1.05-4.16-.79-2.28.29-3.35.61-5.36.89-2.4.34-4.61-1.55-6.84-1.52a9,9,0,0,0-4.32,1.58,9.47,9.47,0,0,1-4.62,1.38c-1.32.11-1.82-.22-3.44.09a7.57,7.57,0,0,0-3.1,1.36A1.22,1.22,0,0,1,4,31.5Z"
              fill="#833921"
            />
          </g>
          <g class="bun-middle">
            <path
              d="M74.49,39.05a4.36,4.36,0,0,1-.18,1.9,5.29,5.29,0,0,1-.92,1.72,1.71,1.71,0,0,1-1.4.59c-31.51-1.39-60.85-.32-65.82-.12A1.5,1.5,0,0,1,5,42.6a4.44,4.44,0,0,1-.72-1.27,6.24,6.24,0,0,1-.33-1.71c.58-.17,1.35-.46,1.87-.59.69-.17,1.54.11,2.66-.13s2.41-1.21,3.28-1.06,2.47,1.71,5.2,1.49a8.53,8.53,0,0,0,4.9-2c.63-.48,1.54-.61,3.12-.41s3.29-.65,4.2-.74,1.82.48,2.76.54a17.3,17.3,0,0,0,2.27-.24A36.59,36.59,0,0,1,38,38c.93.35,2,2.08,3.85,2.1a7.93,7.93,0,0,0,3.78-1.25c.67-.28,1.49,0,3.44-.48a5.42,5.42,0,0,0,3.3-1.91c1.06-1.34,2.53.5,5.09.52,2.86,0,4.44,1.2,6.7,1.72a13.43,13.43,0,0,0,6.48-.46,4.68,4.68,0,0,1,3.93.8Z"
              fill="#e6a65d"
            />
          </g>
          <g class="bun-top">
            <path
              d="M66.34,8.12a48.57,48.57,0,0,0-53.78,0C4.13,13.52,1.15,22.12,4,25.43a.59.59,0,0,0,.66.17,95.72,95.72,0,0,1,34.77-6,95.67,95.67,0,0,1,34.84,6,.41.41,0,0,0,.49-.1C77.81,22.3,74.85,13.58,66.34,8.12ZM45,3.42c1.28.35,0,2-.57,2.74a.2.2,0,0,1-.28,0A.19.19,0,0,1,44,6.06C43.86,5.16,43.61,3.05,45,3.42ZM13.49,18.33a.21.21,0,0,1-.29-.08.2.2,0,0,1,0-.13c.15-.91.62-3,1.75-2.18S14.28,17.87,13.49,18.33Zm4.68-7.57a.25.25,0,0,1-.12,0c-.92-.12-3-.52-2.24-1.68s2,.59,2.44,1.37A.21.21,0,0,1,18.17,10.76Zm5.62,5.49v0c-1.32-.18-.3-2,.2-2.79a.21.21,0,0,1,.28-.06.21.21,0,0,1,.08.11C24.63,14.38,25.16,16.44,23.79,16.25Zm1.7-8.64v0c-1.33.07-.65-1.93-.31-2.78a.2.2,0,0,1,.28-.08.14.14,0,0,1,.09.08C26,5.62,26.88,7.55,25.49,7.61Zm3.58,4h0a.2.2,0,0,1-.28,0,.2.2,0,0,1-.08-.12c-.23-.89-.63-3,.73-2.7S29.61,10.9,29.07,11.64Zm5.6,5h-.08v0c-.89-.25-2.89-.94-2-2s1.85.87,2.22,1.71A.2.2,0,0,1,34.67,16.61ZM33,5.1a.21.21,0,0,1-.19-.23.16.16,0,0,1,0-.09c.66-.65,2.24-2.06,2.7-.75S33.83,5.18,33,5.1Zm5.31,6.62h0a.2.2,0,0,1-.23-.15.24.24,0,0,1,0-.12c.35-.85,1.27-2.76,2.2-1.73S39.14,11.45,38.26,11.72ZM46,14.58c-.37.84-1.35,2.73-2.25,1.67s1.13-1.7,2-1.95a.2.2,0,0,1,.26.11A.2.2,0,0,1,46,14.58Zm5.1-2.35h0a.2.2,0,0,1-.27.09.2.2,0,0,1-.09-.09c-.29-.88-.83-2.93.55-2.75S51.54,11.46,51.05,12.23Zm3.38-5.45c-.81,1.06-1.9-.74-2.33-1.55A.21.21,0,0,1,52.2,5a.16.16,0,0,1,.12,0C53.23,5.15,55.27,5.71,54.43,6.78Zm2.71,9.55v0c-1.2.58-1.36-1.52-1.37-2.44a.21.21,0,0,1,.19-.21.24.24,0,0,1,.14,0C56.82,14.3,58.39,15.78,57.14,16.33ZM61,10.49a.23.23,0,0,1-.18-.05v0c-.73-.56-2.33-1.95-1.09-2.58s1.39,1.5,1.42,2.42A.21.21,0,0,1,61,10.49ZM67,15.58c-.49.79-1.72,2.51-2.46,1.33s1.35-1.52,2.26-1.63a.21.21,0,0,1,.23.17A.28.28,0,0,1,67,15.58Z"
              fill="#e6a65d"
            />
            <path
              d="M44.1,6.18a.2.2,0,0,0,.28,0c.57-.74,1.85-2.39.57-2.74S43.86,5.16,44,6.06A.19.19,0,0,0,44.1,6.18Z"
              fill="#fff"
            />
            <path
              d="M14.93,15.94c-1.13-.82-1.6,1.27-1.75,2.18a.2.2,0,0,0,0,.13.21.21,0,0,0,.29.08C14.28,17.87,16.06,16.76,14.93,15.94Z"
              fill="#fff"
            />
            <path
              d="M15.81,9.1c-.76,1.16,1.32,1.56,2.24,1.68a.25.25,0,0,0,.12,0,.21.21,0,0,0,.08-.29C17.76,9.69,16.57,7.94,15.81,9.1Z"
              fill="#fff"
            />
            <path
              d="M24.27,13.44a.21.21,0,0,0-.28.06c-.5.79-1.52,2.61-.2,2.79v0c1.37.19.84-1.87.56-2.7A.21.21,0,0,0,24.27,13.44Z"
              fill="#fff"
            />
            <path
              d="M25.46,4.79a.2.2,0,0,0-.28.08c-.34.85-1,2.85.31,2.78v0c1.39-.06.46-2,.06-2.74A.14.14,0,0,0,25.46,4.79Z"
              fill="#fff"
            />
            <path
              d="M29.44,8.88c-1.36-.3-1,1.81-.73,2.7a.2.2,0,0,0,.08.12.2.2,0,0,0,.28,0h0C29.61,10.9,30.8,9.18,29.44,8.88Z"
              fill="#fff"
            />
            <path
              d="M32.59,14.65c-.89,1.06,1.11,1.75,2,2v0h.08a.2.2,0,0,0,.14-.25C34.44,15.52,33.48,13.59,32.59,14.65Z"
              fill="#fff"
            />
            <path
              d="M32.79,4.78a.16.16,0,0,0,0,.09A.21.21,0,0,0,33,5.1c.88.08,3,.24,2.54-1.07S33.45,4.13,32.79,4.78Z"
              fill="#fff"
            />
            <path
              d="M38,11.45a.24.24,0,0,0,0,.12.2.2,0,0,0,.23.15c.88-.27,2.9-1,2-2S38.38,10.6,38,11.45Z"
              fill="#fff"
            />
            <path d="M38.28,11.72h0Z" fill="#e6a65d" />
            <path
              d="M45.7,14.3c-.87.25-2.9.89-2,1.95s1.88-.83,2.25-1.67a.2.2,0,0,0,0-.17A.2.2,0,0,0,45.7,14.3Z"
              fill="#fff"
            />
            <path
              d="M51.22,9.48c-1.38-.18-.84,1.87-.55,2.75a.2.2,0,0,0,.09.09.2.2,0,0,0,.27-.09h0C51.54,11.46,52.6,9.66,51.22,9.48Z"
              fill="#fff"
            />
            <path
              d="M52.32,4.93a.16.16,0,0,0-.12,0,.21.21,0,0,0-.1.28c.43.81,1.52,2.61,2.33,1.55S53.23,5.15,52.32,4.93Z"
              fill="#fff"
            />
            <path
              d="M56.1,13.7a.24.24,0,0,0-.14,0,.21.21,0,0,0-.19.21c0,.92.17,3,1.37,2.44v0C58.39,15.78,56.82,14.3,56.1,13.7Z"
              fill="#fff"
            />
            <path
              d="M59.74,7.83c-1.24.63.36,2,1.09,2.58v0a.23.23,0,0,0,.18.05.21.21,0,0,0,.15-.24C61.13,9.33,61,7.2,59.74,7.83Z"
              fill="#fff"
            />
            <path
              d="M66.75,15.28c-.91.11-3,.45-2.26,1.63s2-.54,2.46-1.33a.28.28,0,0,0,0-.13A.21.21,0,0,0,66.75,15.28Z"
              fill="#fff"
            />
          </g>
        </svg>
      </div>
    </button>
  </div>
</template>
  
<script>
export default {
  inheritAttrs: false,
  methods: {
    clickBurger() {
      this.$emit("click");
    },
  },
};
</script>

<style scoped>
.burger-icon .container {
  padding: 10px;
  display: flex;
  align-items: center;
  position: relative;
  width: 100%;
  height: 100%;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -10%);
  justify-content: space-evenly;
}

.burger-icon {
  position: absolute;
  float: right;
  right: -20px;
  bottom: initial;
  margin-top: -14%;
  transition: 0.2s all;
  width: 100px;
  height: 100px;
  background: inherit;
  overflow: hidden;
  border-radius: 50%;
  background-color: rgba(243, 242, 239, 0.774);
  padding: 15px;
  z-index: 10;
}

.big-mac {
  width: 50px;
  height: 60px;
}

@media only screen and (max-width: 550px) {
  .burger-icon {
    position: absolute;
    float: right;
    right: 10px;
    top: 40px;
    bottom: initial;
    margin-top: -38px;
    transition: 0.2s all;
    width: 70px;
    height: 70px;
    background: inherit;
    overflow: hidden;
    border-radius: 50%;
    background-color: rgba(243, 242, 239, 0.774);
    padding: 10px;
    z-index: 10;
  }

  .big-mac {
    width: 30px;
    height: 40px;
  }
}

@media only screen and (min-width: 576px) and (max-width: 990px) {
  .burger-icon {
    position: absolute;
    float: right;
    right: -50px;
    bottom: initial;
    margin-top: -100px;
    transition: 0.2s all;
    width: 90px;
    height: 90px;
    background: inherit;
    overflow: hidden;
    border-radius: 50%;
    background-color: rgba(243, 242, 239, 0.774);
    padding: 10px;
    z-index: 10;
  }
}

@media only screen and (min-width: 992px) and (max-width: 1200px) {
  .burger-icon {
    position: absolute;
    float: right;
    right: -50px;
    bottom: initial;
    margin-top: -100px;
    transition: 0.2s all;
    width: 90px;
    height: 90px;
    background: inherit;
    overflow: hidden;
    border-radius: 50%;
    background-color: rgba(243, 242, 239, 0.774);
    padding: 10px;
    z-index: 10;
  }
}

.big-mac:hover .bun-bottom {
  animation: bun-bottom-down 0.5s forwards;
}

.big-mac:hover .bun-top {
  animation: bun-top-up 0.5s forwards;
}

.big-mac:hover .sauce-bottom {
  animation: sauce-bottom-down 0.5s forwards;
}

.big-mac:hover .beef-bottom {
  animation: beef-bottom-down 0.5s forwards;
}

.big-mac:hover .cheese-bottom {
  animation: cheese-bottom-down 0.5s forwards;
}

.big-mac:hover .lettuce-bottom {
  animation: lettuce-bottom-down 0.5s forwards;
}

.big-mac:hover .sauce-middle {
  animation: sauce-middle-up 0.5s forwards;
}

.big-mac:hover .beef-middle {
  animation: beef-middle-up 0.5s forwards;
}

.big-mac:hover .cheese-middle {
  animation: cheese-middle-up 0.5s forwards;
}

.big-mac:hover .lettuce-middle {
  animation: lettuce-middle-up 0.5s forwards;
}

@keyframes bun-bottom-down {
  from {
    transform: translateY(0px);
  }

  to {
    transform: translateY(14px);
  }
}

@keyframes bun-top-up {
  from {
    transform: rotate(0deg) translateY(0px);
  }

  to {
    transform: rotate(-6deg) translateY(-8px);
  }
}

@keyframes sauce-bottom-down {
  from {
    transform: translateY(0px);
  }

  to {
    transform: translateY(5px);
  }
}

@keyframes beef-bottom-down {
  from {
    transform: translateY(0px);
  }

  to {
    transform: translateY(5px);
  }
}

@keyframes cheese-bottom-down {
  from {
    transform: translateY(0px);
  }

  to {
    transform: translateY(7px);
  }
}

@keyframes lettuce-bottom-down {
  from {
    transform: translateY(0px);
  }

  to {
    transform: translateY(10px);
  }
}

@keyframes sauce-middle-up {
  from {
    transform: translateY(0px);
  }

  to {
    transform: translateY(-5px);
  }
}

@keyframes beef-middle-up {
  from {
    transform: rotate(0deg) translateY(0px);
  }

  to {
    transform: rotate(-5deg) translateY(-5px);
  }
}

@keyframes cheese-middle-up {
  from {
    transform: translateY(0px);
  }

  to {
    transform: translateY(-7px);
  }
}

@keyframes lettuce-middle-up {
  from {
    transform: rotate(0deg) translateY(0px);
  }

  to {
    transform: rotate(-3deg) translateY(-5px);
  }
}
</style>